import { getSubscribersForQueryId } from "../GetSubscribersForQueryId";
export function buildMessageHandler(store) {
    return function messageHandler(msg) {
        return getSubscribersForQueryId(store, msg.id).map(connection => {
            if (typeof msg.error !== "undefined" && typeof connection.onError === "function") {
                connection.onError(msg.error.data);
            }
            else if (typeof msg.result !== "undefined") {
                connection.onData(msg.result);
            }
            return connection;
        });
    };
}
//# sourceMappingURL=BuildMessageHandler.js.map